import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon, XIcon } from 'lucide-react';
import { candidate, languages, mobileExtraNav, primaryNav } from '../../data/site';
import { policies } from '../../data/policies';
type MobileNavProps = {
  open: boolean;
  onClose: () => void;
};
export function MobileNav({
  open,
  onClose
}: MobileNavProps) {
  const [agendaOpen, setAgendaOpen] = React.useState(false);
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);
  return <AnimatePresence data-id="element-524" data-mp="63ctu7ejwil2">
      {open && <motion.div id="mobile-navigation" className="fixed inset-0 z-[90] flex flex-col bg-ink lg:hidden" initial={{
      opacity: 0,
      y: -8
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: -8
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-525" data-mp="15uth5elnboo">
          <div className="flex items-center justify-between border-b border-white/10 px-4 py-4" data-id="element-526" data-mp="1d6nlaavj3v9s">
            <span className="font-display text-lg text-white" data-id="element-527" data-mp="1h7pn8zgtylfg">
              {candidate.initials}
              <span className="ml-1.5 text-gold-400" data-id="element-528" data-mp="1m9f26q76bj8t">{candidate.cycle}</span>
            </span>
            <button type="button" onClick={onClose} aria-label="Close menu" className="flex h-10 w-10 items-center justify-center rounded-lg text-white/80 transition-colors duration-150 ease-emphasis hover:bg-white/10 hover:text-white" data-id="element-529" data-mp="1r65d6z44fond">
              <XIcon aria-hidden className="h-5 w-5" data-id="element-530" data-mp="13gudlkyic0at" />
            </button>
          </div>

          <nav aria-label="Mobile" className="flex-1 overflow-y-auto px-4 py-6" data-id="element-531" data-mp="189dxt0rp9tol">
            <ul className="space-y-1" data-id="element-532" data-mp="atqdnue9uc5w">
              {primaryNav.map(item => item.label === 'Agenda' ? <li key={item.label} data-id="element-533" data-mp="fqgsyfi953q9">
                    <button type="button" onClick={() => setAgendaOpen(value => !value)} aria-expanded={agendaOpen} className="flex w-full items-center justify-between py-3 font-display text-2xl text-white" data-id="element-534" data-mp="7rc623bmu8vx">
                      Agenda
                      <ChevronDownIcon aria-hidden className={`h-5 w-5 text-white/50 transition-transform duration-200 ease-emphasis ${agendaOpen ? 'rotate-180' : ''}`} data-id="element-535" data-mp="cjde1d1rpdg5" />
                    </button>
                    <AnimatePresence initial={false} data-id="element-536" data-mp="3uxcwg9hwnv22">
                      {agendaOpen && <motion.ul initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden pl-4" data-id="element-537" data-mp="3pvnh4hnngv86">
                          {policies.slice(0, 6).map(policy => <li key={policy.slug} data-id="element-538" data-mp="2e4g31ksi50am">
                              <Link to={`/agenda/${policy.slug}`} onClick={onClose} className="block border-l border-white/15 py-2 pl-4 text-[15px] text-white/70 transition-colors duration-150 ease-emphasis hover:text-white" data-id="element-539" data-mp="2e5r8dp1lig3u">
                                {policy.title}
                              </Link>
                            </li>)}
                        </motion.ul>}
                    </AnimatePresence>
                  </li> : <li key={item.label} data-id="element-540" data-mp="3uig08nzyqbu6">
                    <Link to={item.href} onClick={onClose} className="block py-3 font-display text-2xl text-white transition-colors duration-150 ease-emphasis hover:text-gold-300" data-id="element-541" data-mp="3ujh9qo1byq9s">
                      {item.label}
                    </Link>
                  </li>)}
            </ul>

            <ul className="mt-6 space-y-1 border-t border-white/10 pt-6" data-id="element-542" data-mp="1rxwuqs5jfxlr">
              {mobileExtraNav.map(item => <li key={item.label} data-id="element-543" data-mp="2oofkg13ilghb">
                  <Link to={item.href} onClick={onClose} className="block py-2 text-[15px] text-white/70 transition-colors duration-150 ease-emphasis hover:text-white" data-id="element-544" data-mp="2kkrbbdz8icty">
                    {item.label}
                  </Link>
                </li>)}
            </ul>

            <div className="mt-8" data-id="element-545" data-mp="38cewdf9tetob">
              <label htmlFor="mobile-language" className="mb-2 block text-xs font-semibold uppercase tracking-[0.12em] text-white/45" data-id="element-546" data-mp="33jc2t751fk84">
                Language
              </label>
              <select id="mobile-language" defaultValue="English" className="w-full rounded-lg border border-white/20 bg-white/5 px-3 py-2.5 text-[15px] text-white" data-id="element-547" data-mp="3fuwc438ab4pq">
                {languages.map(language => <option key={language} value={language} className="text-ink" data-id="element-548" data-mp="3tunra7ajer5b">
                    {language}
                  </option>)}
              </select>
            </div>
          </nav>

          <div className="border-t border-white/10 p-4" data-id="element-549" data-mp="7fmb6yg4s5jj">
            <Link to="/support" onClick={onClose} className="flex h-[52px] w-full items-center justify-center rounded-lg bg-green-600 text-base font-semibold text-white transition-colors duration-150 ease-emphasis hover:bg-green-700" data-id="element-550" data-mp="cdeawen0ovya">
              Support the Campaign
            </Link>
          </div>
        </motion.div>}
    </AnimatePresence>;
}